module.exports = __webpack_public_path__ + "static/media/pizza-milano-cover.3a09413f.jpg";